<template lang="pug">
  //- combo drug
  div.drug-panel
    div.drug-panel--head
      button.btn.btn-info.icon-right(@click="createForm = true") 新增藥組
      CreateSpecialMedicineForm(v-if="createForm" v-on:closeForm="closeForm" :medicineType="'control'" v-on:dataCreated="dataCreated")
    vuetable(
      ref="vuetableCombo"
      :track-by="'id'"
      :api-mode="false"
      :fields="comboField"
      pagination-path=""
      :css="boostrapCss"
      detail-row-component="control-detail"
      @vuetable:cell-clicked="onControlClicked"
      item-actions="itemActions"
    )
      template(slot="actions" slot-scope="props")
        button.btn.btn-danger.btn-sm(@click="deleteControl(props.rowData)") 刪除套藥
</template>


<script>
import Vue from 'vue';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import ControlDrugDetail from './ControlDrugDetail';
import CreateSpecialMedicineForm from '../../common/CreateSpecialMedicineForm';

Vue.component('control-detail', ControlDrugDetail);

export default {
  name: 'DrugDBSettings',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      comboField: [
        {
          name: 'medication.generic_name',
          title: '管制藥組名稱',
        },
        {
          name: 'pairsCount',
          title: '數量',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '動作',
          titleClass: 'text-center w-25',
          dataClass: 'text-center',
        },
      ],
      itemActions: [
        {
          name: 'delete-combo',
          label: '刪除套藥',
          icon: 'glyphicon glyphicon-zoom-in',
          class: 'btn btn-info',
          extra: { title: 'View' },
        },
      ],
      server,
      comboSet: {},
      createForm: false,
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
    CreateSpecialMedicineForm,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  async created() {
    await this.getControlDrugCategory();
    await this.getControlSet();
  },
  methods: {
    async dataCreated() {
      this.closeForm();
      await this.getControlDrugCategory();
      await this.getControlSet();
    },
    closeForm() {
      this.createForm = false;
    },
    getControlDrugCategory() {
      this.comboSet = {};
      return this.instance.get('/api/medication/', {
        params: {
          type: 'control',
        },
      })
      .then((res) => {
        res.data.results.forEach((medication) => {
          this.comboSet[medication.id] = {
            medication,
            combo: [],
            pairsCount: 0,
            id: medication.id,
          };
        });
      });
    },
    onControlClicked(data, field, event) {
      this.$refs.vuetableCombo.toggleDetailRow(data.id);
    },
    getControlSet() {
      return this.instance.get('/api/control-medication-set/')
      .then((res) => {
        res.data.forEach((pair) => {
          const oneSet = this.comboSet[pair.parent_medication.id];
          oneSet.combo.push(
            { medication: pair.child_medication, dose: pair.child_medication_quantity, relation_id: pair.id },
          );
          oneSet.pairsCount += 1;
        });
        this.$refs.vuetableCombo.setData(Object.values(this.comboSet));
      });
    },
    deleteControl(data) {
      return this.instance.delete(`/api/medication/${data.id}/`)
      .then(async (res) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
        await this.getControlDrugCategory();
        await this.getControlSet();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ControlDrugSettings.vue?8939c59e